import { typedQueryClient, useTypedQuery } from "hooks/useTypedQuery";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";

import type { PaginatedHistoryInvoices } from "modules/ExactMonitoring/queryKeys";

export const usePaginatedHistoryInvoices = () => useTypedQuery({ queryKey: ExactFailuresQueryKeys.paginatedHistoryInvoices, initialData: { data: [] } }).data;
export const setPaginatedHistoryInvoices = (data: PaginatedHistoryInvoices) => typedQueryClient.setQueryData(ExactFailuresQueryKeys.paginatedHistoryInvoices, data);
export const getPaginatedHistoryInvoices = () => typedQueryClient.getQueryData(ExactFailuresQueryKeys.paginatedHistoryInvoices) || { data: [] };
